import React from 'react';
import './Public.css';

// Coquille commune des pages publiques : carte centrée, en-tête société + A97.
export default function Coquille({ societe, marque, children }) {
  return (
    <div className="pb-page">
      <div className="pb-carte">
        <div className="pb-entete">
          <div className="pb-societe">{societe || 'Vos préférences de contact'}{marque && <span className="pb-marque">{marque}</span>}</div>
          <div className="pb-a97" aria-label="A97 RGPD">A<span className="or">97</span><span className="app">RGPD</span></div>
        </div>
        {children}
      </div>
      <div className="pb-pied">Gestion des consentements du groupe A97 · vos choix sont enregistrés avec une preuve horodatée que vous pouvez consulter à tout moment.</div>
    </div>
  );
}

export function messagePublic(e, defaut) {
  const code = e?.response?.data?.error;
  if (code === 'deja_repondu') return 'Vous avez déjà répondu à cette demande. Pour changer d\'avis, utilisez le lien « changer d\'avis » reçu dans votre confirmation.';
  if (code === 'expire') return 'Ce lien a expiré (60 jours). Rien n\'a changé : nous ne vous contacterons pas sans votre accord.';
  if (e?.response?.status === 404) return 'Ce lien est inconnu. Vérifiez l\'adresse reçue par SMS ou e-mail.';
  if (e?.response?.status === 429) return 'Trop de tentatives, réessayez dans quelques minutes.';
  return e?.response?.data?.message || defaut || 'Une erreur est survenue, réessayez plus tard.';
}
